import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { AdminProductCard, NumberSpinner } from '@mercadoni/gungnir'

import { Button } from 'antd'

const MODE = {
  ADD: 'ADD',
  UPDATE: 'UPDATE'
}

const UNITS = {
  kg: {
    name: 'kg'
  },
  g: {
    name: 'g'
  },
  mg: {
    name: 'mg'
  },
  lb: {
    name: 'lb'
  },
  gal: {
    name: 'gal'
  },
  l: {
    name: 'L'
  },
  ml: {
    name: 'mL'
  },
  gr: {
    name: 'gr'
  }
}

const ProductCard = ({
  copy,
  mode,
  productQty,
  removeProduct,
  updateProduct,
  rejectProduct,
  undoRejection,
  product,
  isLoading,
  sendComment,
  disabled,
  showRejectItem = false,
  showUndo = false,
  allowAddComment = true
}) => {
  const [value, setValue] = useState(productQty || 0)

  const [showCommentForm, setShowCommentForm] = useState(false)
  const [edit, setEdit] = useState(false)

  const { um = '' } = product
  const unit = um.toLowerCase()

  const add = (newValue) => {
    if (mode === MODE.ADD && !showCommentForm) {
      setShowCommentForm(true)
      setEdit(true)
    } else {
      setValue(newValue)
    }
  }

  const remove = () => {
    removeProduct()
    setEdit(false)

    if (mode === MODE.ADD) {
      setShowCommentForm(false)
    }
  }

  const ready = (newValue) => {
    updateProduct(newValue)
  }

  const updateComment = (comment) => {
    if (mode === MODE.ADD) {
      sendComment(value, comment)
      setEdit(false)
      setShowCommentForm(false)
    } else {
      sendComment(comment)
      setShowCommentForm(false)
    }
  }

  const cancelComment = () => {
    setEdit(false)
    setShowCommentForm(false)
  }

  useEffect(() => {
    setValue(productQty)
  }, [productQty])

  useEffect(() => {
    return () => {
      setShowCommentForm(false)
      setEdit(false)
    }
  }, [])

  return (
    <div className='product-card'>
      <AdminProductCard
        product={{ ...product, um: unit }}
        mode={mode}
        showCommentForm={showCommentForm}
        allowAddComment={allowAddComment}
        sendComment={updateComment}
        cancelComment={cancelComment}
        onReject={rejectProduct}
        onUndoRejection={undoRejection}
        loading={isLoading}
        showRejectItem={showRejectItem}
        showUndo={showUndo}
        slot={
          mode === MODE.ADD && !edit ? (
            <Button onClick={add}>{copy('add')}</Button>
          ) : (
            <NumberSpinner
              disabledButtonAddItem={
                product.quantityFoundLimits != null ? (value > product.quantityFoundLimits.max ? true : false) : false
              }
              mode={mode}
              value={value}
              min={UNITS[unit] ? 0.1 : 1}
              showRemoveButtonOnMin={mode !== MODE.ADD}
              showReadyButton={mode !== MODE.ADD}
              showHoverButtons={!disabled}
              edit={edit && !disabled}
              editable={!!UNITS[unit]}
              allowEditOnBlur={mode === MODE.ADD}
              um={UNITS[unit] ? UNITS[unit].name : ''}
              onAdd={add}
              onSubstract={setValue}
              onChange={(value) => {
                setValue(value)
                if (!!UNITS[unit]) {
                  setValue(value)
                }
              }}
              onRemove={remove}
              copy={copy}
              onReady={ready}
            />
          )
        }
        copy={copy}
      />
    </div>
  )
}

ProductCard.propTypes = {
  productQty: PropTypes.number.isRequired,
  product: PropTypes.object,
  removeProduct: PropTypes.func,
  subtractQty: PropTypes.func,
  addQty: PropTypes.func,
  showRejectItem: PropTypes.bool,
  showUndo: PropTypes.bool,
  allowAddComment: PropTypes.bool,
  mode: PropTypes.oneOf([MODE.ADD, MODE.UPDATE]),
  copyReadyButton: PropTypes.string,
  updateProduct: PropTypes.func,
  rejectProduct: PropTypes.func,
  undoRejection: PropTypes.func,
  copy: PropTypes.func,
  isLoading: PropTypes.bool,
  sendComment: PropTypes.func,
  disabled: PropTypes.bool,
  itemV1: PropTypes.bool
}

ProductCard.defaultProps = {
  productQty: 0,
  product: {
    minQty: 1,
    um: '',
    image: '',
    price: {},
    title: '',
    pum: '',
    instructions: '',
    contentUnits: '',
    attributes: {}
  },
  allowAddComment: true,
  rejectProduct: () => {},
  undoRejection: () => {},
  removeProduct: () => {},
  updateProduct: () => {},
  sendComment: () => {},
  mode: MODE.ADD,
  copy: {},
  isLoading: false,
  disabled: false,
  itemV1: false
}

export default ProductCard
